import React from "react";
import styled, { css } from "styled-components";

import {
  BasicModal,
  BasicModalProps
} from "src/library/components/Modal";
import { Button } from "src/library/components/Button";
import { Text } from "src/library/components/Text";

interface DeleteDashboardModelProps extends Pick<BasicModalProps, "onDismiss" | "open"> {
  dashboardName?: string;
  onConfirm: () => void;
  isLoading: boolean;
}

// Basic model asking user to confirm deletion of a dashboard.
export const DeleteDashboardModel: React.ReactFCWithChildren<DeleteDashboardModelProps> = ({
  onDismiss, open, dashboardName, onConfirm, isLoading
}) => {
  return (
    <StyledBasicModal
      title="Delete Dashboard"
      open={open}
      onDismiss={onDismiss}
    >
      <Text>
        {`Are you sure you want to delete the ${dashboardName ? ` "${dashboardName}" ` : ""}dashboard?`}
      </Text>

      <div className="action-buttons">
        <Button
          $buttonType="secondary"
          onClick={onDismiss}
        >
          Cancel
        </Button>

        <Button
          $buttonType="primary"
          onClick={onConfirm}
          loading={isLoading}
        >
          Delete Dashboard
        </Button>
      </div>
    </StyledBasicModal>
  );
};

const StyledBasicModal = styled(BasicModal)`
  ${({ theme }) => css`    
    .action-buttons {
      margin-top: ${theme.spacing.margins.lg};
      display: flex;
      justify-content: space-between;
    }
  `}
`;
